TS.ns('WL');

WL.transitionReasonModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this,
            stateList;

        me.parent(config);

        stateList = me.getDomainProperty('dgDocumentTypeStateCollection_Property');
        if (stateList != null) {
            stateList.on('addNew', me.onStateAdded);
        } 
    },

    onStateAdded: function (e) {
        var me = this,
         rec = e.item;

        rec.DocumentStateXReasonCollection = ko.observableArray([]);
    }
});